import AvailableBalanceCard from "./available-balance-card";
import {
  SpendAccount,
  useSpendOrganizationAccountsQuery,
} from "graphql/generated";
import { useEffect, useState } from "react";
import { FormatMoney } from "helpers/format-money";
import AllAccounts from "./all-accounts";
// import { SpendLiteWidget } from "../../../../node_modules/@snap-mobile/spend-lite-widget/dist";
import { SpendLiteWidget } from "@snap-mobile/spend-lite-widget";
import { useAppContexts } from "hooks/use-context";
import { TIER1 } from "../../../constants";

function LiteDashboard() {
  const { program } = useAppContexts();
  const [totalBalance, setTotalBalance] = useState(0);
  const [accounts, setAccounts] = useState<SpendAccount[]>([]);
  const [env, setEnv] = useState<
    "production" | "staging" | "development" | "local"
  >("staging");

  const { loading: loadingAccounts, data: accountData } =
    useSpendOrganizationAccountsQuery();

  useEffect(() => {
    if (
      !loadingAccounts &&
      accountData &&
      accountData.spendOrganizationAccounts
    ) {
      let spendAccounts = accountData.spendOrganizationAccounts;
      setTotalBalance(spendAccounts.totalBalance ?? 0);
      setAccounts(spendAccounts.accounts as SpendAccount[]);
    }
    // eslint-disable-next-line
  }, [loadingAccounts, accountData]);

  useEffect(() => {
    if (process.env.REACT_APP_GRAPHQL_URI === "https://api.snap.app/") {
      setEnv("production");
    } else {
      setEnv("staging");
    }
  }, []);

  return (
    <>
      <div className="card">
        <div>
          {program?.isLite ? (
            <SpendLiteWidget
              environment={env}
              tier={program.tier}
              isAddDebitCardsEnabled={program.isDebitCardEnabled}
            />
          ) : (
            <AvailableBalanceCard totalAvailable={FormatMoney(totalBalance)} />
          )}
        </div>
      </div>
      {program?.tier !== TIER1 && (
        <AllAccounts accounts={accounts} loadingAccounts={loadingAccounts} />
      )}
    </>
  );
}

export default LiteDashboard;
